import { STRING } from "../constants/string";

/**
 * "/en/ui-kit/filters?r=0" => "/en/ui-kit/filters"
 */
export const getUrlPathName = (url: string): string => {
  const [pathName] = url.split(STRING.QUESTION);
  return pathName;
};
